import React, { useMemo, useEffect } from "react";
import { Label, FormFeedback, FormGroup } from "reactstrap";
import Select from "react-select";
import { useDispatch } from "react-redux";

import { getClassifiedInformationTypes } from "common/services/persons.service";
import { normalize } from "common/lib/normalize";

const SelectCIType = ({
  validation,
  index,
  label,
}: {
  validation: any;
  index: number;
  label?: string;
}) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation.touched.classifiedInformation?.[index]
          ?.classifiedInformationType &&
        validation.errors.classifiedInformation?.[index]
          ?.classifiedInformationType
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation.touched.classifiedInformation?.[index]
            ?.classifiedInformationType &&
          validation.errors.classifiedInformation?.[index]
            ?.classifiedInformationType
            ? "red"
            : "#ced4da",
      },
    }),
  };

  const dispatch: any = useDispatch();

  const [data, setData] = React.useState([]);
  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response = await getClassifiedInformationTypes();
        setData(normalize(response.data));
        setError(null);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [dispatch, setLoading]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: `${el?.name || ""}`,
      };
    });
  }, [data]);

  return (
    <FormGroup>
      <Label
        htmlFor={`classifiedInformation[${index}].classifiedInformationType`}
        className="form-label"
      >
        {label ? label : "Classified Information Type"}
      </Label>
      <Select
        name={`classifiedInformation[${index}].classifiedInformationType`}
        id={`classifiedInformation[${index}].classifiedInformationType`}
        value={
          validation.values.classifiedInformation[index]
            ?.classifiedInformationType?.value
            ? validation.values.classifiedInformation[index]
                ?.classifiedInformationType
            : null
        }
        placeholder="Select classified information type"
        onChange={(value: any) => {
          validation.setFieldValue(
            `classifiedInformation[${index}].classifiedInformationType`,
            value
          );
          validation.setFieldError(
            `classifiedInformation[${index}].classifiedInformationType`,
            ""
          );
        }}
        options={options}
        onBlur={() =>
          validation.setFieldTouched(
            `classifiedInformation[${index}].classifiedInformationType`,
            true
          )
        }
        className={
          validation.touched.classifiedInformation?.[index]
            ?.classifiedInformationType &&
          validation.errors.classifiedInformation?.[index]
            ?.classifiedInformationType
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        isLoading={loading}
      />
      <FormFeedback>
        {validation.errors.classifiedInformation?.[index]
          ?.classifiedInformationType?.value || ""}
      </FormFeedback>
    </FormGroup>
  );
};

export default SelectCIType;
